import React from 'react';

const RouteIcon = ({ svgRef, title, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" ref={svgRef} width="54" height="42" viewBox="0 0 54 42">
    <title>{title}</title>
    <g>
      <g>
        <path
          fill="#c9c9c9"
          d="M45.354 36.75a2.621 2.621 0 0 1-2.618-2.624 2.621 2.621 0 0 1 2.618-2.625 2.621 2.621 0 0 1 2.618 2.625 2.621 2.621 0 0 1-2.618 2.625zM8.635 10.5a2.621 2.621 0 0 1-2.617-2.624A2.621 2.621 0 0 1 8.635 5.25a2.621 2.621 0 0 1 2.618 2.625A2.621 2.621 0 0 1 8.635 10.5zm29.328 21h-3.095a5.248 5.248 0 0 1-5.245-5.25v-10.5c0-5.798-4.697-10.5-10.492-10.5h-3.094A7.868 7.868 0 0 0 .75 7.877 7.868 7.868 0 1 0 16.037 10.5h3.094a5.248 5.248 0 0 1 5.246 5.25v10.5c0 5.799 4.697 10.5 10.491 10.5h3.095a7.867 7.867 0 0 0 15.234-3.53 7.87 7.87 0 0 0-7.838-6.97 7.869 7.869 0 0 0-7.396 5.25z"
        />
      </g>
    </g>
  </svg>
);

export default RouteIcon;



// WEBPACK FOOTER //
// ./src/common/icons/RouteIcon.js